import { browserLogger } from 'utils/logger/browserLogger';

const ADDITIONAL_ATTRIBUTION_SESSION_KEY =
  'topsort_additional_attribution_impressions_v1';

const logger = browserLogger();

const readTrackedKeys = (): Set<string> => {
  if (typeof window === 'undefined') {
    return new Set();
  }

  try {
    const rawValue = window.sessionStorage.getItem(
      ADDITIONAL_ATTRIBUTION_SESSION_KEY
    );

    if (!rawValue) {
      return new Set();
    }

    const parsed = JSON.parse(rawValue) as string[];

    if (!Array.isArray(parsed)) {
      return new Set();
    }

    return new Set(parsed);
  } catch (error) {
    logger.warn(
      {
        message: 'Unable to read additional attribution dedup keys from sessionStorage',
        data: JSON.stringify({
          key: ADDITIONAL_ATTRIBUTION_SESSION_KEY,
          error: error instanceof Error ? error.message : String(error)
        })
      },
      'additionalAttributionDedup'
    );

    return new Set();
  }
};

const writeTrackedKeys = (keys: Set<string>): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage.setItem(
      ADDITIONAL_ATTRIBUTION_SESSION_KEY,
      JSON.stringify(Array.from(keys))
    );
  } catch (error) {
    logger.warn(
      {
        message: 'Unable to persist additional attribution dedup keys to sessionStorage',
        data: JSON.stringify({
          key: ADDITIONAL_ATTRIBUTION_SESSION_KEY,
          error: error instanceof Error ? error.message : String(error)
        })
      },
      'additionalAttributionDedup'
    );
  }
};

export const hasTrackedAdditionalAttributionInSession = (
  key: string
): boolean => {
  if (!key) {
    return false;
  }

  return readTrackedKeys().has(key);
};

export const markAdditionalAttributionAsTrackedInSession = (
  key: string
): void => {
  if (!key) {
    return;
  }

  const trackedKeys = readTrackedKeys();
  trackedKeys.add(key);
  writeTrackedKeys(trackedKeys);
};
